interface ICreateImageUrlOptions {
    width?: number
    height?: number
    resolution?: number
    aspectRatio?: number
    format?: 'auto' | 'jpeg'
    quality?: number
}

export const createImageUrl = (path: string, options?: ICreateImageUrlOptions) => {
    const aspectRatio = options?.aspectRatio
    // round to the nearest whole number
    const width = Math.round(options?.width ?? 0)
    const height = Math.round(options?.height ?? (aspectRatio ? width / aspectRatio : 0))

    const resolution = options?.resolution ?? 2

    const url = `${path}?format=${options?.format || 'auto'}&width=${width * resolution}&height=${height * resolution}${options?.quality ? `&quality=${options.quality}` : ''}`

    return url
}
